import { useState } from "react";
import { IFAQ } from "./adminFaqs";
import AdminToast from "../../../core/admin/adminToast";
import AdminSwitch from "../../../core/admin/adminSwitch";
import AdminButton from "../../../core/admin/adminButton";
import AdminSpinner from "../../../core/admin/adminSpinner";
import { adminInputClass } from "../../../core/admin/adminTextInput";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import EditFAQModal from "./editFaqModal";

export default function FAQ({ faq, goodToast, refresh, reorder }: { faq: IFAQ, goodToast: () => void, refresh: (f: IFAQ) => void, reorder: boolean }) {

    const [loading, setLoading] = useState(false);
    const [badToast, setBadToast] = useState(false);
    const [order, setOrder] = useState(faq.order);
    const [modal, setModal] = useState(false);

    const editFaq = async (fields: {}) => {
        try {
            setLoading(true);
            const docRef = doc(db, "faqs", faq.id);
            await updateDoc(docRef, fields);
            refresh({ ...faq, ...fields });
            goodToast();
        } catch (error) {
            console.log(error);
            setBadToast(true);
        } finally {
            setLoading(false);
        }
    }

    const handleOrder = (value: string) => {
        if (value === "") {
            setOrder(0);
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        if (parseInt(value) > 99) {
            return null;
        }
        setOrder(parseInt(value));
    }

    const saveOrder = async () => {
        try {
            setLoading(true);
            const docRef = doc(db, "faqs", faq.id);
            await updateDoc(docRef, { order });
            refresh({ ...faq, order });
            goodToast();
        } catch (error) {
            console.log(error);
            setBadToast(true);
        } finally {
            setLoading(false);
        }
    }

    const finish = (faq: IFAQ) => {
        refresh(faq);
        setModal(false);
        goodToast();
    }

    if (loading) {
        return (
            <li className="flex items-center justify-center rounded-xl border border-gray-200 p-4 text-gray-500">
                <AdminSpinner />
            </li>
        )
    }

    return (
        <li className="flex flex-col md:flex-row md:items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 md:p-4">
            {
                reorder ?
                    <div className="flex items-center gap-2 shrink-0">
                        <label className="text-xs font-semibold text-gray-600" htmlFor={`faq-order-${faq.id}`}>Posição</label>
                        <input id={`faq-order-${faq.id}`} inputMode="numeric" className={`${adminInputClass} !w-14 h-8 !px-2 text-center`} type="text" value={order} onChange={e => handleOrder(e.target.value)} />
                        <AdminButton size="sm" onClick={saveOrder} disabled={order === faq.order}>Salvar</AdminButton>
                    </div>
                    : null
            }
            <p className="flex-1 min-w-0 font-semibold text-gray-900 break-words">{faq.question}</p>
            <div className="flex items-center justify-between md:justify-end gap-4 border-t border-gray-100 pt-3 md:border-0 md:pt-0">
                <AdminSwitch on={faq.display} onClick={() => editFaq({ display: !faq.display })} label={faq.display ? "Visível" : "Oculta"} className="md:w-28" />
                <AdminButton size="sm" variant="secondary" onClick={() => setModal(true)}>Ver</AdminButton>
            </div>
            {
                modal ?
                    <EditFAQModal finish={finish} close={() => setModal(false)} faq={faq} />
                    : null
            }
            <AdminToast toast={badToast} setToast={setBadToast} tone="danger" message="Erro!" />
        </li>
    )
}